module.exports = __webpack_public_path__ + "static/media/tenth_southside_school1.ff4b0628.jpg";